import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(): any {
    return this.http.get(`${environment.apiWhs}/Location/GetAllLocations`);
  }

  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiWhs}/Location/UpdateLocation`, data);
    } else {
      return this.http.post(`${environment.apiWhs}/Location/CreateLocation`, data);
    }
  }

  getDetails(id: number) {
    return this.http.get(`${environment.apiWhs}/Location/GetDetails/${id}`);
  }

  isActiveLocation(Id: number) {
    return this.http.post(`${environment.apiWhs}/Location/IsActiveLocation/${Id}`, null);
  }

  locationDefinition(areaId:number) {
    return this.http.get(`${environment.apiWhs}/Location/LocationDefinition?areaId=${areaId}`);
  }

  importExcelFile(id:number,data: any) {
    return this.http.post(`${environment.apiWhs}/Location/ImportExcelFile?AreaId=${id}`, data);
  }

  exportLocationstoExcel(id:number): any {
    return this.http.get(`${environment.apiWhs}/Location/ExportLocationstoExcel?AreaId=${id}`, { responseType: 'blob' });
  }

  downloadFile() {
    return this.http.get(`${environment.apiWhs}/Location/DownloadFile`, { responseType: 'blob' });
  }
}

